<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

#app .search-section {
  padding: 12px 16px !important;
  margin-bottom: 12px !important;
}

#app .table-section {
  padding: 12px 16px !important;
}

#app .section-title {
  font-size: 13px !important;
  margin-bottom: 10px !important;
}

#app .el-form-item {
  margin-bottom: 10px !important;
  margin-right: 16px !important;
}

#app .el-form-item__label {
  font-size: 12px !important;
  padding-right: 8px !important;
}

#app .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  font-size: 12px !important;
}

#app .el-input__icon {
  line-height: 28px !important;
}

#app .el-select .el-input__inner {
  height: 28px !important;
}

#app .el-button {
  padding: 6px 12px !important;
  font-size: 12px !important;
}

#app .el-button--small {
  padding: 5px 10px !important;
  font-size: 12px !important;
}

#app .el-table td,
#app .el-table th {
  padding: 6px 0 !important;
}

#app .el-table .cell {
  padding: 0 8px !important;
  font-size: 12px !important;
}

#app .el-tag {
  padding: 0 5px !important;
  height: 18px !important;
  line-height: 16px !important;
  font-size: 11px !important;
}

#app .el-button--text {
  padding: 2px 4px !important;
  font-size: 12px !important;
}

#app .el-pagination {
  margin-top: 12px !important;
  font-size: 12px !important;
}

#app .el-pagination .el-pager li {
  min-width: 26px !important;
  height: 26px !important;
  line-height: 26px !important;
  font-size: 12px !important;
}

#app .el-pagination button {
  min-width: 26px !important;
  height: 26px !important;
  line-height: 26px !important;
  font-size: 12px !important;
}

#app .toolbar {
  margin-bottom: 10px !important;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(144, 147, 153, 0.5);
}

.el-aside::-webkit-scrollbar {
  width: 4px;
}

.el-aside::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.el-aside::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}
</style>
